import { render, staticRenderFns } from "./UsOnlineWeb.vue?vue&type=template&id=ded2632c&scoped=true&"
import script from "./UsOnlineWeb.vue?vue&type=script&lang=js&"
export * from "./UsOnlineWeb.vue?vue&type=script&lang=js&"
import style0 from "./UsOnlineWeb.vue?vue&type=style&index=0&id=ded2632c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded2632c",
  null
  
)

export default component.exports